import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';

//import { AppModule as FillWebComponent } from '../../../fill/src/app/app.module'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DragDropModule } from '@angular/cdk/drag-drop';

// Ngrx-Common
import { StoreModule } from '@ngrx/store';
import { EffectsModule} from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ROOT_REDUCERS } from './../app/infrastructure/store/app.state';
// Ngrx-Effects
import { FormEffects } from './../app/infrastructure/store/effects/form.effects';
import { VersionEffects } from './../app/infrastructure/store/effects/version.effects';
import { ValueEffects } from './../app/infrastructure/store/effects/value.effects';
import { TemplateEffects } from './../app/infrastructure/store/effects/template.effects';
// Common
import { environment } from "../environments/environment";
import { AuthInterceptorProvider, LayoutModule } from '@mangosoft/mango-layout';
import { AuthModule } from '@mangosoft/mango-login';
import { AuthGuard } from './infrastructure/guards/auth/auth.guard';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { JwtModule } from '@auth0/angular-jwt';
// Translate
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// Modules
import { DashboardModule } from './ui/pages/dashboard/dashboard.module';
import { FillModule } from './ui/pages/fill/fill.module';
import { LandingModule } from './ui/pages/landing/landing.module';
import {
  NoopAnimationsModule,
  BrowserAnimationsModule,
} from '@angular/platform-browser/animations';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export function tokenGetter(): string {
  const cookie = new CookieService(document, null);
  return cookie.get('auth_key');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    //FillWebComponent,
    DragDropModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    AuthModule,
    FillModule,
    DashboardModule,
    LandingModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return '';
        },
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      progressAnimation: 'increasing',
    }),
    StoreModule.forRoot(ROOT_REDUCERS),
    EffectsModule.forRoot([
      FormEffects,
      VersionEffects,
      ValueEffects,
      TemplateEffects
    ]),
		StoreDevtoolsModule.instrument({
			maxAge: 25,
			logOnly: environment.production,
		}),
		!environment.production ? StoreDevtoolsModule.instrument() : [],
		JwtModule.forRoot({
			config: {
				tokenGetter: () => {
					return "";
				},
			},
		}),
    BrowserAnimationsModule,
    NoopAnimationsModule,
  ],
  providers: [AuthGuard, CookieService, AuthInterceptorProvider],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
